import { ENV_VARS } from '@/env';
import { oidcConfigServices } from '@/modules/oidc';
import { services as oidcServices } from '@nvision/oidc';

export const logOut = () => {
  const isIdentity = ENV_VARS.REACT_APP_OIDC_AUTHORITY && ENV_VARS.REACT_APP_OIDC_CLIENT_ID;
  if (isIdentity) {
    oidcServices.auth.removeUser(oidcConfigServices);
  }
  localStorage.clear();
  window.location.reload();
};

export const setUserLocalStorage = ({ token, ...rest }: { token: string }) => {
  localStorage.setItem('token', token);
  localStorage.setItem('userInfo', JSON.stringify(rest));
};

export const getUserLocalStorage = () => {
  const token = localStorage.getItem('token');
  const userInfo = localStorage.getItem('userInfo');

  if (token && userInfo) {
    return { token, userInfo: JSON.parse(userInfo) };
  }
  return undefined;
};
